/** Internal schema version; UI label is {@link HRV_PREPROCESSING_LABEL}. */
export const PREPROCESSING_VERSION = 2 as const;

export const HRV_PREPROCESSING_LABEL = 'HRV preprocessing' as const;

export const NN_SOURCE = 'hr-derived-polar360' as const;

export const SMOOTH_PRIORS_LAMBDA = 500;

export const RESAMPLE_HZ = 4 as const;

export const MAX_CORRECTED_BEAT_RATIO = 0.05;

export const MIN_HR_BPM = 30;

export const MAX_HR_BPM = 220;

/** Max relative change vs previous beat (Malik-style threshold, common in Kubios docs). */
export const ARTIFACT_MAX_RELATIVE_CHANGE = 0.2;

export const ARTIFACT_METHOD = 'malik-inspired-relative-change' as const;

export const DETREND_METHOD = 'smooth-priors' as const;

export const RMSSD_SOURCE = 'nn-delta-rr' as const;

export const SPECTRAL_PATH_PRIMARY = 'nn-reconstructed' as const;

export const SPECTRAL_PATH_DEVICE = 'device' as const;
